import * as React from 'react';
import { FC } from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import { ISanityTextNode } from '@rbi-ctg/menu';

import { StyledText } from './loyalty-text-widget.styled';

export interface ITextWidgetProps {
  text: ISanityTextNode;
}

const LoyaltyTextWidget: FC<React.PropsWithChildren<ITextWidgetProps>> = ({
  text,
}: ITextWidgetProps) => {
  return <StyledText newUI={false}>{text.locale}</StyledText>;
};

export default makeUclComponent(LoyaltyTextWidget);
